import React, { useEffect } from 'react';
import './Summary.scss';
import PersonalizationContainer from '../../containers/PersonalizationContainer';
import Button from '../Button';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import Icon from '../Icon';
import bem from '../../utils/bem';
import useCar from '../../utils/hooks/useCar';
import Pencil from './SVG/Pencil';
import Close from './SVG/Close';
import Counter from '../Counter/Counter';
import { StyleRoot } from 'radium';
import { ANIMATIONS, getCampaingIfApplies, isPartOfGasDiscount, isPartOfModelsWithoutDiscount } from '../../utils/constants';
import { capitalize } from '../../utils/helpers';
import useVersion from '../../utils/hooks/useVersion';
import Whatsapp from './SVG/Whatsapp';
import SubmitModal from './SubmitModal';
import SubmitModalDescuento from './SubmitModalDescuento';
import VideoCallButton from '../VideoCallButton/VideoCallButton';
import { useContext } from 'react';
import VirtualTourContext from '../../utils/VirtualTourContext';

const CouponItem = ({
  car,
  checkCoupon,
  coupon,
  finalPriceWithCoupon,
  isGasDiscount
}) => {
  const [couponText, setCoupon] = useState('');
  return (
    <>
      <div
      className={bem('summary-table__item', {
        'blank': false,
        'coupon': true,
        'is-loading': coupon.isLoading
      })}
      >
        <input value={couponText} type="text" placeholder="Digite un cupón" onChange={(e) => {
          setCoupon(e.target.value);
        }}/>
        <button 
          onClick={() => { 
            setCoupon('');
            checkCoupon(couponText);
          }}
        >
          Aplicar cupón
        </button>
      </div>
      {!isGasDiscount && car.descuentoAplicado && (
        <div className={bem('summary-table__item', {
          'minicuota': true,
          'price-coupon': true,
        })}>
          <div className="summary-table__item-parent">
            <span className="summary-table__item-label">
              <span className="price-total">Precio Total</span>
              <span>
                Cupón aplicado de:
              </span>
            </span>
            <span className="summary-table__item-price summary-table__item-price--coupon">
              <Counter value={finalPriceWithCoupon} />
              <Counter value={car.descuentoGerencia} className="cupon" />
            </span>
          </div>
        </div>
      )}
      
    </>
  );
};

const DescuentoItem = ({
  car,
  finalPriceWithCoupon,
  descuentoWeb,
  isGasDiscount,
}) => {
  return (
    <>
      {car.descuentoWebAplicado && (
        <>
          {/* <SummaryTableItem
            label="Descuento Aplicado"
            price={descuentoWeb?.price || descuentoWeb?.monto}
            isRed={true}
            labelRed={true}
          /> */}
          <div className={bem('summary-table__item', {
            'minicuota': true,
            'price-coupon': true,
          })}>
            <div className="summary-table__item-parent">
              <span className="summary-table__item-label">
                <span className="price-total">Precio Total</span>
                <span>
                  Con descuento aplicado:
                </span>
              </span>
              <span className="summary-table__item-price summary-table__item-price--coupon">
                <Counter value={finalPriceWithCoupon} />
                {/* <Counter value={descuentoWeb.monto} className="cupon" /> */}
              </span>
            </div>
          </div>
        </>
      )}
      
    </>
  );
};

const SummaryTableItem = ({
  type,
  onDelete,
  items = [],
  isRed,
  label,
  price,
  topBorder,
  topBottom,
  isFullyRed,
  labelRed,
  minicuota
}) => {
  const [opened, setOpened] = useState(true);
  return (
    <div
      className={bem('summary-table__item', {
        'border-top': topBorder,
        'border-bottom': topBottom,
        'red': isFullyRed,
        minicuota
      })}
    >
      <div className="summary-table__item-parent">
        {items.length > 0 ? (
          <button
            className="summary-table__item-label"
            onClick={() => setOpened(!opened)}
          >
            {label}{' '}
            <span
              className={bem('summary-table__item-label-arrow', {
                opened,
              })}
            >
              <Icon type="down-arrow" />
            </span>
          </button>
        ) : (
          <span className={bem('summary-table__item-label', {
            'red': labelRed
          })}>{label}</span>
        )}
        <span
          className={bem('summary-table__item-price', {
            red: isRed,
          })}
        >
          {<Counter value={price} />}
        </span>
      </div>
      {opened &&
        items.map(item => (
          <StyleRoot key={item.id}>
            <div
              className="summary-table__item-subitem"
              style={ANIMATIONS.fadeIn}
            >
              <span className="summary-table__item-label">{item.label}</span>
              <span
                className={bem('summary-table__item-price', {
                  red: isRed,
                })}
              >
                <Counter value={item.price} />
                <div className="summary-table__item-price__options">
                  <Link to={`../${type}/?back=true${item.internalCat ? `&cat=${item.internalCat}`:''}`}>
                    <Pencil />
                  </Link>
                  <button onClick={() => onDelete(item)}>
                    <Close />
                  </button>
                </div>
              </span>
            </div>
          </StyleRoot>
        ))}
    </div>
  );
};

const videoCallButton = (
  <>
    <div>
      <VideoCallButton text={'Video llamada'} isSummary={true}/>
    </div>
  </>
);

const SummaryTable = ({
  car,
  selectAccessory,
  pickMaintenance,
  pickInsurance,
  checkCoupon,
  coupon,
  descuentoWeb,
  isGasDiscount,
  campaingOverride,
}) => {
  const {
    accsPrice,
    finalPrice,
    insurancePrice,
    maintenacePrice,
    selectedInsurance,
    selectedAccesories,
    selectedMaintenance,
    cuota,
    selectedBank,
    hasDescuentoGerencia,
    finalPriceWithCoupon,
  } = useCar(car);

  const {
    hasActivePromo
  } = useVersion();

  const toTableModel = array => {
    return array.map(a => ({
      id: a.id,
      price: a.precioVenta || a.precio,
      label: capitalize(a.nombre),
      internalCat: a?.tipo
    }));
  };

  const cuotaTitle = (hasActivePromo) => {
    if (!hasActivePromo) {
      return `Cuota ${selectedBank?.post_type || ''}`;
    }
    return (
      <>
        Cuota mensual <br /> Mini cuotas
      </>
    );
  }
  return (
    <div className="summary-table">
      <SummaryTableItem
        label="Precio Promocional"
        price={car?.precioOferta}
        isRed={true}
      />
      {accsPrice > 0 && (
        <SummaryTableItem
          label="Accesorios"
          type="accesorios"
          price={accsPrice}
          items={toTableModel(selectedAccesories)}
          // topBorder={true}
          onDelete={item =>
            selectAccessory(selectedAccesories.find(a => a.id === item.id))
          }
        />
      )}
      {maintenacePrice > 0 && (
        <SummaryTableItem
          label="Mantenimiento"
          type="mantenimientos"
          price={maintenacePrice}
          items={
            !selectedMaintenance ? [] : toTableModel([selectedMaintenance])
          }
          // topBorder={true}
          onDelete={item => pickMaintenance(selectedMaintenance.id)}
        />
      )}
      <SummaryTableItem
        label="Precio Total"
        price={finalPrice}
        // topBorder={true}
        isRed={true}
        isFullyRed={true}
        minicuota={hasActivePromo}
      />
      {insurancePrice > 0 && (
        <SummaryTableItem
          label="Seguro"
          type="seguros"
          price={insurancePrice}
          items={!selectedInsurance ? [] : toTableModel([selectedInsurance])}
          // topBorder={true}
          onDelete={item => pickInsurance(selectedInsurance)}
        />
      )}
      <SummaryTableItem
        label={cuotaTitle(hasActivePromo)}
        price={cuota}
        minicuota={hasActivePromo}
        // topBorder={true}
      />
      {hasDescuentoGerencia && !car.descuentoWebAplicado && (
        <CouponItem 
          car={car}
          checkCoupon={checkCoupon}
          coupon={coupon}
          finalPriceWithCoupon={finalPriceWithCoupon}
          isGasDiscount={isGasDiscount}
        />
      )}

      {!isGasDiscount && car.descuentoWebAplicado && !car.descuentoAplicado && (
        <DescuentoItem 
          car={car}
          descuentoWeb={campaingOverride || descuentoWeb}
          finalPriceWithCoupon={finalPriceWithCoupon}
          isGasDiscount={isGasDiscount}
        />
      )}
    </div>
  );
};

const Summary = ({
  personalization,
  pickMaintenance,
  selectAccessory,
  pickInsurance,
  checkCoupon,
  resetCouponRequest,
  sendCouponForm,
  sendCotizacion,
  sendDescuentoRequest,
}) => {
  const [descuentoAplicadoLocal, setDescuentoAplicadoLocal] = useState(false);
  const virtualTourContext = useContext(VirtualTourContext);
  const { activeCampaign } = virtualTourContext;
  const car = personalization.data;
  const [showModal, setShowModal] = useState(false);
  const [descuentoShowModal, setDescuentoShowModal] = useState(false);
  const hideDiscountBanner = isPartOfModelsWithoutDiscount(car?.modelo || '');

  //Variable booleana para ver si se activa el boton de video llamada o no 
  const videoCallOn = car?.videoCallOption === "1";

  const descuentoWeb = personalization?.additional?.descuentoWeb;
  useEffect(() => {
    if (car?.descuentoAplicado && !personalization.submittedCouponForm && !showModal) {
      setShowModal(true);
    }
  }, [car, personalization.submittedCouponForm, showModal]);

  const isGasDiscount = isPartOfGasDiscount(car?.codigo, car?.anio, activeCampaign);
  const campaingOverride = getCampaingIfApplies(car?.modelo, car?.codigoAnio);
  return (
    <PersonalizationContainer
      options={
        <div className="summary-actions">
          {!hideDiscountBanner && descuentoWeb && !car?.descuentoWebAplicado && !descuentoAplicadoLocal ? (
            <>
            {/* {(isGasDiscount || descuentoWeb?.banner) && <span class="summary-actions__banner" onClick={() => setDescuentoShowModal(true)}>
              <img src={isGasDiscount ? 'https://veinsamotors.com/wp-content/uploads/2023/06/3323-BANNER-COMBUSTIBLE-02.webp' : 
              (campaingOverride ? campaingOverride.summaryImage : descuentoWeb?.banner)} alt="Banner" />
            </span>} */}
            {(isGasDiscount || campaingOverride) && (
              <span class="summary-actions__banner" onClick={() => setDescuentoShowModal(true)}>
                <img src={campaingOverride ? campaingOverride.summaryImage : 'https://veinsamotors.com/wp-content/uploads/2023/06/3323-BANNER-COMBUSTIBLE-02.webp'} alt="Banner" />
              </span>
            )}

            {/* <h6>Aplica este descuento para tu próximo chuzo</h6>
            <h5 style={{'text-align':'right', 'font-size': '4rem'}}>${descuentoWeb.monto}</h5> */}
            <div className="summary-buttons summary-buttons__descuento-web">
              <Button type="red" newStyle uppercase onClick={() => setDescuentoShowModal(true)}>
                {/* Aplicar Descuento */}
                enviar información
              </Button>
              <Button component={Link} to={'../reservar/'} type="red" newStyle uppercase>
                Reservar o Comprar
              </Button>
              {/* <Button component={'a'} target="_blank" href={'https://wa.me/50664658000?text=Hola%20quiero%20contactarme%20con%20sales'} green newStyle black uppercase>
                <Whatsapp /> Whatsapp
              </Button> */}
            </div>
            </>
          ): (
            <>
            <h5>¿Qué queres hacer ahora?</h5>
            <div className="summary-buttons">
              {(!descuentoWeb && (!isGasDiscount || campaingOverride === null)) && (
                <Button type="white" newStyle uppercase onClick={() => setDescuentoShowModal(true)}>
                  Enviar Información
                </Button>
              )}
              <Button component={Link} to={'../reservar/'} type="red" newStyle uppercase>
                Reservar o Comprar
              </Button>
              {/* <Button component={'a'} target="_blank" href={'https://wa.me/50664658000?text=Hola%20quiero%20contactarme%20con%20sales'} green newStyle black uppercase>
                <Whatsapp /> Whatsapp
              </Button> */}
              { videoCallOn && (
                <>
                <div className="summary-buttons-videocall-button">
                  <p class="summary-buttons-videocall-button-text">Solicitá una video llamada.</p>
                  {videoCallButton}
                </div>
                </>
              )}
            </div>
            </>
          )}
        </div>
      }
      isSummary={true}
      title={
        <>
        El chuzo que querias <strong>{personalization.data?.modelo} {personalization.data?.anio}</strong>
        </>
      }
    >
      <div className="summary">
        {personalization.data && (
          <SummaryTable
            car={car}
            pickMaintenance={pickMaintenance}
            selectAccessory={selectAccessory}
            pickInsurance={pickInsurance}
            checkCoupon={checkCoupon}
            coupon={personalization.coupon}
            descuentoWeb={descuentoWeb}
            isGasDiscount={isGasDiscount}
            campaingOverride={campaingOverride}
          />
        )}
      </div>
      <SubmitModalDescuento 
        sendInfo={(form) => {
          sendCotizacion(form, descuentoWeb, isGasDiscount, campaingOverride);
          setDescuentoShowModal(false);
          if (!isGasDiscount) {
            sendDescuentoRequest();
          } else {
            setDescuentoAplicadoLocal(true);
          }
        }}
        colorCode={car?.colorCode}
        showModal={descuentoShowModal} 
        onClose={() => {
          setDescuentoShowModal(false);
        }}
      />
      <SubmitModal 
        sendInfo={(form) => {
          sendCouponForm(personalization.coupon.coupon, form, car.descuentoGerencia);
          setShowModal(false);
        }}
        colorCode={car?.colorCode}
        showModal={showModal} 
        onClose={() => {
          resetCouponRequest();
          setShowModal(false);
        }
      }/>
    </PersonalizationContainer>
  );
};

export default Summary;
